import { REQUEST_METHOD_POST, REQUEST_METHOD_GET } from '@/common/js/common';

export default [
    // 生日礼二级页面信息
    {
        subUrl: '/growth/award/getbirthdaycouponpageinfo', // 请求url
        name: 'getbirthdaycouponpageinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 提前还免息费查询接口
    {
        subUrl: '/growth/award/getPaidOffAheadPageInfo', // 请求url
        name: 'getPaidOffAheadPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 提前还免息费领券接口
    {
        subUrl: '/growth/award/receivePaidOffAheadCoupon', // 请求url
        name: 'receivePaidOffAheadCoupon', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },

    // 秒杀
    {
        subUrl: '/mktop/timeService/getTime', // 请求url
        name: 'getTime', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 秒杀
    {
        subUrl: '/growth/award/getSecKillBenefitPageInfo', // 请求url
        name: 'getbenefitdaypageinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 秒杀
    {
        subUrl: '/growth/award/receiveSecKillBenefit', // 请求url
        name: 'receivebenefitdaycoupon', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 升级礼包
    {
        subUrl: '/growth/award/getGiftPackInfoV2', // 请求url
        name: 'getGiftPackInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 实物礼包领取异常报错
    {
        subUrl: '/growth/award/hasFailRec', // 请求url
        name: 'hasFailRec', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 实物礼包虚拟卡卡密查询接口
    {
        subUrl: '/growth/award/queryVcardInfo', // 请求url
        name: 'queryVcardInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },

    // 升级礼包领取接口
    {
        subUrl: '/growth/award/receiveGiftAwardV2', // 请求url
        name: 'receiveGiftAward', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 新增地址接口--需要登录
    {
        subUrl: '/growth/award/saveAddress',
        name: 'addAddress',
        needToken: true,
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询最新地址接口--需要登录
    {
        subUrl: '/growth/award/getLatestAddress',
        name: 'queryTopOneAddress',
        needToken: true,
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 客服二级页面
    {
        subUrl: '/growth/award/getCustomerPageInfov2', // 请求url
        name: 'getCustomerPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 生日礼领券
    {
        subUrl: '/growth/award/receivebirthdaycoupon', // 请求url
        name: 'receivebirthdaycoupon', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 获取权益首页信息
    {
        subUrl: '/growth/home/getHomePageInfo', // 请求url
        name: 'getHomePageInfo', // 接口调用名
        needToken: false, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 获取任务列表
    {
        subUrl: '/growth/home/getTaskListV2', // 请求url
        name: 'getTaskListV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询生活福袋页面信息
    {
        subUrl: '/growth/award/getluckybagpageinfov2', // 请求url
        name: 'getluckybagpageinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 首页积分记录Toast接口
    {
        subUrl: '/growth/home/getHomePageScoreLogToasts', // 请求url
        name: 'homePageScoreLogToasts', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 领取活力值接口
    {
        subUrl: '/growth/home/receiveTaskScore', // 请求url
        name: 'receiveTaskScore', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 写入开启通知权限接口
    {
        subUrl: '/growth/home/notifyPermission', // 请求url
        name: 'notifyPermission', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 获取生活福袋第三方页面URL接口
    {
        subUrl: '/growth/award/getluckybagurlv2', // 请求url
        name: 'getluckybagurl', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 积分记录查询接口
    {
        subUrl: '/growth/score/getUserGrowthScorePageInfo', // 请求url
        name: 'userGrowthScorePageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询实物限制地区接口
    {
        subUrl: '/growth/award/getRestrictArea', // 请求url
        name: 'getRestrictArea', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询权益汇总信息接口
    {
        subUrl: '/growth/duiba/getbenefitsummary', // 请求url
        name: 'getbenefitsummary', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // V2.5查询首页信息接口V2
    {
        subUrl: '/growth/home/getHomePageInfoV2', // 请求url
        name: 'getHomePageInfoV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询权益信息列表接口
    {
        subUrl: '/growth/duiba/getbenefitlist', // 请求url
        name: 'getbenefitlist', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // V2.5查询待领活力值气泡接口
    {
        subUrl: '/growth/home/getBubbleScoreList', // 请求url
        name: 'getBubbleScoreList', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询兑吧权益详情接口
    {
        subUrl: '/growth/duiba/getbenefitdetail', // 请求url
        name: 'getbenefitdetail', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // V2.5领取活力值气泡接口
    {
        subUrl: '/growth/home/receiveBubbleScore', // 请求url
        name: 'receiveBubbleScore', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // V2.5查询等级权益信息接口
    {
        subUrl: '/growth/home/getgradebenefitinfo', // 请求url
        name: 'getgradebenefitinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // V2.5查询实物奖品领取记录接口
    {
        subUrl: '/growth/award/getReceiveAwardRecord', // 请求url
        name: 'getReceiveAwardRecord', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询用户引导弹窗接口
    {
        subUrl: '/growth/notice/getUserNotice', // 请求url
        name: 'getUserNotice', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 设置通知状态接口
    {
        subUrl: '/growth/notice/setNoticeStatus', // 请求url
        name: 'setNoticeStatus', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询兑吧权益详情接口
    {
        subUrl: '/growth/duiba/receive', // 请求url
        name: 'receive', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // V2.5查询兑吧权益领取记录接口
    {
        subUrl: '/growth/duiba/getreceiverecordlist', // 请求url
        name: 'getreceiverecordlist', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 领取免息券礼品接口
    {
        subUrl: '/growth/award/receiveFreeInterestBenefit', // 请求url
        name: 'receiveFreeInterestBenefit', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询免息券页面信息接口
    {
        subUrl: '/growth/award/getFreeInterestBenefitPageInfo', // 请求url
        name: 'getFreeInterestBenefitPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询话费券页面信息接口
    {
        subUrl: '/growth/award/getPhoneBenefitPageInfo', // 请求url
        name: 'getPhoneBenefitPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 领取话费券礼品接口
    {
        subUrl: '/growth/award/receivePhoneBenefit', // 请求url
        name: 'receivePhoneBenefit', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 领取还款券礼品接口
    {
        subUrl: '/growth/award/receiveRepaymentBenefit', // 请求url
        name: 'receiveRepaymentBenefit', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询还款券礼品接口
    {
        subUrl: '/growth/award/getRepaymentBenefitPageInfo', // 请求url
        name: 'getRepaymentBenefitPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 查询营销任务栏接口
    {
        subUrl: '/growth/home/getMarketingBar', // 请求url
        name: 'getMarketingBar', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 通知访问活动任务完成接口
    {
        subUrl: '/growth/home/notifyLLHDongTaskDone', // 请求url
        name: 'notifyLLHDongTaskDone', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询悬浮窗信息接口
    {
        subUrl: '/growth/home/getFloatingWindowInfoV2', // 请求url
        name: 'getFloatingWindowInfoV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询活力值升级进度V2接口
    {
        subUrl: '/growth/home/getScoreProgressV2', // 请求url
        name: 'getScoreProgressV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询活力值升级进度接口
    {
        subUrl: '/growth/home/getScoreProgress', // 请求url
        name: 'getScoreProgress', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 首页-查询0等级权益信息接口
    {
        subUrl: '/growth/home/getnogradebenefitinfo', // 请求url
        name: 'getnogradebenefitinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    {
        subUrl: '/growth/award/getzkqbenefitpageinfo',
        name: 'getzkqbenefitpageinfo',
        needToken: true,
        method: REQUEST_METHOD_POST,
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    {
        subUrl: '/growth/award/receivezkqbenefit',
        name: 'receivezkqbenefit',
        needToken: true,
        method: REQUEST_METHOD_POST,
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 领取浮动权益
    {
        subUrl: '/growth/home/receiveFloatBenefit', // 请求url
        name: 'receiveFloatBenefit', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 领取浮动权益
    {
        subUrl: '/growth/award/isShowPopup', // 请求url
        name: 'isShowTabPopUp', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 全部权益页接口
    {
        subUrl: '/growth/benefit/getAllGradeGrowthBenefitInfo', // 请求url
        name: 'getAllGradeGrowthBenefitInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 全部权益-查询等级权益信息
    {
        subUrl: '/growth/benefit/getCurrentGradeBenefitInfo', // 请求url
        name: 'getCurrentGradeBenefitInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 全部权益-查询全部的等级权益信息V2
    {
        subUrl: '/growth/benefit/getCurrentGradeBenefitInfoV2', // 请求url
        name: 'getCurrentGradeBenefitInfoV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 全部权益-查询全部的权益解锁值
    {
        subUrl: '/growth/benefit/getBenefitLockInfo', // 请求url
        name: 'getBenefitLockInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 跳过新手引导接口
    {
        subUrl: '/growth/notice/skipnoviceguide', // 请求url
        name: 'skipnoviceguide', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询任务栏接口
    {
        subUrl: '/growth/home/getAuthTaskbar', // 请求url
        name: 'gettaskbar', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 新手权益领取
    {
        subUrl: '/growth/home/receivenovicebenefit', // 请求url
        name: 'receivenovicebenefit', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 活力值领取记录查询接口，/records/energy
    {
        subUrl: '/growth/score/getScoreLogPageInfoV2', // 请求url
        name: 'getScoreLogPageInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: true
    },
    // 签到任务信息接口
    {
        subUrl: '/growth/home/getSignInTaskInfo', // 请求url
        name: 'getSignInTaskInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 获取场景列表接口
    {
        subUrl: '/growth/home/getSceneList', // 请求url
        name: 'getSceneList', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 获取场景文案接口
    {
        subUrl: '/growth/home/getSceneWords', // 请求url
        name: 'getSceneWords', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 文案曝光通知接口
    {
        subUrl: '/growth/home/notifySceneWordDisplay', // 请求url
        name: 'notifySceneWordDisplay', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询新人权益信息接口
    {
        subUrl: '/growth/home/getnovicebenefitinfo', // 请求url
        name: 'getnovicebenefitinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询营销任务栏任务信息接口
    {
        subUrl: '/growth/home/getMarketingBarTaskInfo', // 请求url
        name: 'getMarketingBarTaskInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 领取签到任务接口
    {
        subUrl: '/growth/home/takeSignInTask', // 请求url
        name: 'takeSignInTask', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询新人引导新人权益信息接口
    {
        subUrl: '/growth/home/getnovicebenefitinfoinnoviceguide', // 请求url
        name: 'getnovicebenefitinfoinnoviceguide', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询新人引导新人权益信息接口
    {
        subUrl: '/growth/ranking/getrankingpopup', // 请求url
        name: 'getrankingpopup', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询新人引导新人权益信息接口
    {
        subUrl: '/growth/ranking/saverankingpopuprecord', // 请求url
        name: 'saverankingpopuprecord', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询进行中的榜单活动id接口
    {
        subUrl: '/growth/home/getCurrentRankingActivityId', // 请求url
        name: 'getCurrentRankingActivityId', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询进行中的榜单活动信息
    {
        subUrl: '/growth/ranking/getrankingactivityinfo', // 请求url
        name: 'getrankingactivityinfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 领取成功弹窗上报接口
    {
        subUrl: '/growth/award/reportPopup', // 请求url
        name: 'reportPopup', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 实物礼包维护信息下发接口
    {
        subUrl: '/growth/award/maintenceInfo', // 请求url
        name: 'maintenceInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询任务栏接口
    {
        subUrl: '/growth/home/getBubbleTaskList', // 请求url
        name: 'getBubbleTaskList', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询营销任务栏任务信息接口 v4.0
    {
        subUrl: '/growth/home/getBubbleBarTaskInfo', // 请求url
        name: 'getBubbleBarTaskInfo', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 判断是否命中新分值灰度接口
    {
        subUrl: '/growth/score/isShootNewScore', // 请求url
        name: 'isShootNewScore', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 任务领取接口
    {
        subUrl: '/growth/home/taskReceive', // 请求url
        name: 'taskReceive', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询好礼抢兑状态接口 v4.6
    {
        subUrl: '/growth/home/getAwardStatusAndGray', // 请求url
        name: 'getAwardStatusAndGray', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
    // 查询福利日banner接口 v4.6
    {
        subUrl: '/growth/home/getBenefitDayBanner', // 请求url
        name: 'getBenefitDayBanner', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST, // post/get 请求
        showNetToast: false,
        showBusinessToast: false,
        showLoading: false
    },
];
